// components/PolicyBadges.jsx
import { Chip, Stack } from "@mui/material";

const badgeColors = {
  return: { bg: "#e8f5e9", color: "#2e7d32" },
  shipping: { bg: "#e3f2fd", color: "#1565c0" },
  warranty: { bg: "#fff3e0", color: "#ef6c00" },
};

export default function PolicyBadges({ badges = [] }) {
  if (!badges.length) return null;

  // Separate badges by line
  const firstLineBadges = badges.filter(b => b.type === "return" || b.type === "shipping");
  const secondLineBadges = badges.filter(b => b.type === "warranty");

  return (
    <Stack direction="column" spacing={0.5} alignItems="center">
      {/* First line: return & shipping */}
      {firstLineBadges.length > 0 && (
        <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent="center">
          {firstLineBadges.map((b, i) => (
            <Chip
              key={i}
              label={b.label}
              size="small"
              sx={{
                bgcolor: badgeColors[b.type]?.bg,
                color: badgeColors[b.type]?.color,
                fontWeight: 600,
                fontSize: '0.7rem',
                height: '20px',
                borderRadius: '4px',
                '& .MuiChip-label': {
                  px: 1,
                },
              }}
            />
          ))}
        </Stack>
      )}
      {/* Second line: warranty */}
      {secondLineBadges.length > 0 && (
        <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent="center">
          {secondLineBadges.map((b, i) => (
            <Chip
              key={i}
              label={b.label}
              size="small"
              sx={{
                bgcolor: badgeColors[b.type]?.bg,
                color: badgeColors[b.type]?.color,
                fontWeight: 600,
                fontSize: '0.7rem',
                height: '20px',
                borderRadius: '4px',
                '& .MuiChip-label': {
                  px: 1,
                },
              }}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
}